import { render } from "./SeparatorTitle.vue?vue&type=template&id=1d769eac&scoped=true"
import script from "./SeparatorTitle.vue?vue&type=script&lang=js"
export * from "./SeparatorTitle.vue?vue&type=script&lang=js"

import "./SeparatorTitle.vue?vue&type=style&index=0&id=1d769eac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1d769eac"

export default script